export const OrderStatus = {
    Placed: 'Placed',
    Accepted: 'Accepted',
    Paid: 'Paid',
    Cancelled: 'Cancelled',
    Rejected: 'Rejected',
    InProgress: 'InProgress',
    ReadyToPickup: 'ReadyToPickup',
    OutForDelivery: 'OutForDelivery',
    Delivered: 'Delivered',
    PickedUp: 'PickedUp',
    Completed: 'Completed',
    Abandonned: 'Abandonned',
    Lost: 'Lost'
  };